import request from '@/utils/request'

// 名校风采-培训专区分页
export function getEliteSchool(data) {
	return request({
		url:'/app-api/biz/home/get-eliteSchool-page',
		method: 'get',
		params: data
	})
}

// 名校风采-培训专区详情
export function getDetail(data) {
	return request({
		url:'/app-api/biz/home/get-elite-school',
		method: 'get',
		params: data
	})
}